import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class RegistyPermissionService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    get(){
        return Vue.axios.get(`${API_HOST}/api/RegistryPermission`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }
}

export default new RegistyPermissionService()